var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from 'angular-ts-decorators';
import { asRequestBody } from '../../shared/util/as-request-body';
import { resetLoadingBtns, setLoadingBtn } from '../../shared/util/loading-button-util';
let VerifyTwoFactorCodeController = class VerifyTwoFactorCodeController {
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = [];
    /** Current value of the login code, required for clean password-bullet handling */
    loginCode = '';
    codeInput;
    submitLoginCode;
    mask;
    constructor() { }
    ngOnInit() {
        this.codeInput = document.getElementById('code-input');
        this.submitLoginCode = document.getElementById('submitLoginCode');
        this.mask = document.getElementById('code-mask');
    }
    async verifyOneTimeLoginCode(e) {
        if (e) {
            setLoadingBtn(e);
        }
        const formData = new FormData(document.getElementById('twoFactorCodeForm'));
        const body = asRequestBody(formData);
        const response = await fetch('/two-factor-code/verify' + window.location.search, {
            method: 'POST',
            body,
        });
        const responseJson = await response.json();
        if (response.ok && responseJson.redirectUrl) {
            window.location.href = responseJson.redirectUrl;
            return;
        }
        else {
            this.showError(responseJson.error);
        }
        resetLoadingBtns();
    }
    preventInvalidTwoFactorCodeInput(e) {
        const newValue = e.target.value.substring(0, e.target.selectionStart) +
            (e.data ?? '') +
            e.target.value.substring(e.target.selectionEnd);
        if (new RegExp('[^0-9]', 'g').test(newValue)) {
            e.preventDefault();
        }
    }
    onTwoFactorCodeChanged() {
        const text = this.loginCode;
        this.clearErrors();
        if (text.length === 6) {
            // Hide the blinking input caret because it would appear past the last character after maximum is already reached
            this.codeInput.classList.add('hide-input-caret');
            // Focus on the submit button to allow for quick submission and hide
            // extra space after last character where caret would appear
            this.submitLoginCode.focus();
        }
        else {
            this.codeInput.classList.remove('hide-input-caret');
        }
        this.mask.innerHTML = text + '•'.repeat(6 - text.length);
    }
    showError(error) {
        if (error === 'INVALID_2FA_CODE') {
            this.codeInput.classList.add('error');
            document.getElementById('invalidTwoFactorCode').style.display = 'block';
        }
        else {
            // Unknown error
            document.getElementById('unknownError').style.display = 'block';
        }
    }
    clearErrors() {
        this.codeInput.classList.remove('error');
        document.getElementById('invalidTwoFactorCode').style.display = 'none';
    }
};
VerifyTwoFactorCodeController = __decorate([
    Component({
        selector: 'app-verify-two-factor-code',
        // no associated template, is embedded static HTML-page in the server assets
    }),
    __metadata("design:paramtypes", [])
], VerifyTwoFactorCodeController);
export { VerifyTwoFactorCodeController };
